import { FormControl, FormGroup, Validators } from '@angular/forms';
import { LocalStorageService } from 'ngx-webstorage';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import 'rxjs/add/operator/takeWhile';
import { NotyfService } from 'ng-notyf';
import { environment } from '../../../../environments/environment';
import { CartService } from '../../../services/cart.service';
import { RemovePastOrderComponent } from '../remove-cart-past-order/remove-past-order.component';
import { ConfigurationService } from '../../../services/config.service';
import { CartDatesPromptComponent } from '../cart-dates-prompt/cart-dates-prompt.component';
var MyCartComponent = /** @class */ (function () {
    function MyCartComponent(localSt, cartService, configAPI, modalService, notyfService) {
        this.localSt = localSt;
        this.cartService = cartService;
        this.configAPI = configAPI;
        this.modalService = modalService;
        this.notyfService = notyfService;
        this.itemIndex = 0;
        this.alive = true;
        this.interval = 5000;
        this.showMyCart = false;
        this.environment = environment;
        this.cartItems = [];
        this.deliveryFeeTotal = 0;
        this.singleDayDeliveryFeeTotal = 0;
        this.orderTotal = 0;
        this.taxAmount = 0;
        this.grandTotal = 0;
        this.youMayEnjoyReqObj = { dates: [], items: [] };
        this.youMayEnjoyItems = [];
        this.suggestedItems = [];
        this.addAnotherDelivery = false;
        this.showPromoCodeForm = false;
        this.showPromoCodeApplied = false;
        this.invalidPromo = false;
        this.appliedPromoObject = {};
        this.errorMessage = '';
        this.showOrderTotalDetail = false;
        this.showDeliveryFeeDetail = false;
        this.disableCheckOutButton = false;
        this.showMinimumSpendError = false;
        this.minimumSpendErrorMessage = '';
        this.cantRemoveFreeItem = false;
        this.hideSuggested = false;
        this.freeItemNotAvailable = false;
        this.freeItemNotAvailableMessage = '';
        this.showYouMayEnjoyLoader = false;
        this.cartItemsLengths = [];
        this.widthGreater600 = true;
        this.promoFreeItemDiscount = 0;
    }
    MyCartComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.createForm();
        this.localSt.store('showMyCart', false);
        this.showMyCart = this.localSt.retrieve('showMyCart');
        this.localSt.observe('showMyCart').subscribe(function (res) {
            _this.showMyCart = res;
            window.scrollTo(0, 0);
        });
        if (this.localSt.retrieve('widthGreater600')) {
            this.widthGreater600 = this.localSt.retrieve('widthGreater600');
        }
        this.localSt.observe('widthGreater600').subscribe(function (res) {
            _this.widthGreater600 = res;
        });
        if (this.localSt.retrieve('cartItems')) {
            this.cartItems = this.localSt.retrieve('cartItems');
            this.cartItems.forEach(function (results) {
                _this.cartItemsLengths.push({ date: results.date, length: results.items.length });
            });
            this.cartItemSort();
            this.deliveryCharges();
            this.disableCheckOutFunc();
            if (this.cartItems.length <= 1) {
                this.cartItems.forEach(function (dateObj) {
                    if (dateObj.datePast) {
                        _this.hideSuggested = true;
                    }
                });
            }
            if (!this.localSt.retrieve('appliedPromo')) {
                this.cartItems.forEach(function (dateObj) {
                    dateObj.items.forEach(function (item) {
                        item.freeItem = false;
                    });
                });
            }
        }
        this.localSt.observe('cartItems').subscribe(function (items) {
            if (items) {
                _this.cartItems = items;
                _this.cartItemSort();
                _this.priceLoopFunction();
                _this.disableCheckOutFunc();
                _this.deliveryCharges();
                if (_this.cartItems.length <= 1) {
                    _this.cartItems.forEach(function (dateObj) {
                        if (dateObj.datePast) {
                            _this.hideSuggested = true;
                        }
                    });
                }
                var youMayEnjoyRefresh_1 = false;
                if (_this.cartItems.length) {
                    if (!_this.cartItemsLengths.length) {
                        youMayEnjoyRefresh_1 = true;
                    }
                    else {
                        _this.cartItems.forEach(function (dateObj) {
                            _this.cartItemsLengths.forEach(function (lengthDateObj) {
                                if (dateObj.date === lengthDateObj.date && dateObj.items.length !== lengthDateObj.length) {
                                    youMayEnjoyRefresh_1 = true;
                                }
                            });
                        });
                    }
                }
                if (youMayEnjoyRefresh_1) {
                    _this.youMayDateFunction();
                    _this.youMayEnjoyFunction();
                }
            }
            if (!items.length) {
                _this.cartItems.forEach(function (dateObj) {
                    dateObj.items.forEach(function (item) {
                        item.freeItem = false;
                    });
                });
                _this.localSt.clear('appliedPromo');
                _this.appliedPromoObject = {};
                _this.showPromoCodeApplied = false;
                _this.showPromoCodeForm = false;
                _this.showMinimumSpendError = false;
                _this.freeItemNotAvailable = false;
                _this.priceLoopFunction();
            }
        });
        this.localSt.observe('appliedPromo').subscribe(function (appliedPromoParam) {
            if (!appliedPromoParam) {
                _this.cartItems.forEach(function (dateObj) {
                    dateObj.items.forEach(function (item) {
                        item.freeItem = false;
                    });
                });
                // this.localSt.clear('appliedPromo');
                _this.showPromoCodeApplied = false;
                _this.showPromoCodeForm = false;
                _this.showMinimumSpendError = false;
                _this.freeItemNotAvailable = false;
                _this.priceLoopFunction();
            }
            else {
                _this.appliedPromoObject = appliedPromoParam;
                _this.showPromoCodeApplied = true;
                _this.priceLoopFunction();
            }
        });
        this.localSt.observe('currentDate').subscribe(function (currentDate) {
            if (currentDate) {
                _this.currentDate = currentDate;
                _this.priceLoopFunction();
            }
        });
        if (this.localSt.retrieve('currentDate')) {
            this.currentDate = this.localSt.retrieve('currentDate');
        }
        this.priceLoopFunction();
        if (this.cartItems.length) {
            if (this.localSt.retrieve('zenUser')) {
                this.configAPI.tokenTest().subscribe(function (res) {
                    if (res.success) {
                        _this.youMayDateFunction();
                        _this.youMayEnjoyFunction();
                    }
                });
            }
            else {
                this.youMayDateFunction();
                this.youMayEnjoyFunction();
            }
        }
        setInterval(function () {
            if (_this.youMayEnjoyItems && _this.youMayEnjoyItems.length > 1) {
                _this.itemIndex++;
                _this.itemIndex === 2 ? _this.itemIndex = 0 : _this.itemIndex = 1;
                _this.youMayEnjoyItemsShow = {
                    image: _this.youMayEnjoyItems[_this.itemIndex].zf_image_web,
                    price: _this.youMayEnjoyItems[_this.itemIndex].zf_price,
                    name: _this.youMayEnjoyItems[_this.itemIndex].zf_name,
                    id: _this.youMayEnjoyItems[_this.itemIndex].zf_id
                };
            }
        }, 5000);
        if (this.localSt.retrieve('appliedPromo')) {
            this.appliedPromoObject = this.localSt.retrieve('appliedPromo');
            this.showPromoCodeApplied = true;
            this.priceLoopFunction();
        }
        this.localSt.observe('appliedPromo').subscribe(function (promo) {
            if (promo) {
                _this.showPromoCodeApplied = true;
                _this.showPromoCodeForm = false;
                _this.appliedPromoObject = _this.localSt.retrieve('appliedPromo');
                _this.priceLoopFunction();
            }
        });
        if (this.localSt.retrieve('validZipCode')) {
            this.deliveryCharges();
        }
        this.localSt.observe('validZipCode').subscribe(function (validZip) {
            if (validZip) {
                _this.deliveryCharges();
            }
        });
        this.disableCheckOutFunc();
    };
    MyCartComponent.prototype.ngOnDestroy = function () {
        this.alive = false; // switches your TimerObservable off
    };
    MyCartComponent.prototype.createForm = function () {
        this.addPromoForm = new FormGroup({
            promocode: new FormControl('', [Validators.required, Validators.maxLength(50)]),
        });
    };
    MyCartComponent.prototype.itemPlus = function (item, date) {
        item.cantRemoveFreeItem = false;
        this.cartService.addItemFromCart(item, date);
    };
    MyCartComponent.prototype.itemMinus = function (item, date) {
        if (item.count === 1 && item.freeItem) {
            item.cantRemoveFreeItem = true;
        }
        else {
            if (item.count === 1) {
                //   this.localSt.store('dateFromRemoveItem', date);
                //   this.modalService.open(RemoveCartItemComponent, { backdrop: 'static', keyboard: false }).result.then((response) => {
                //     if (response) {
                //       this.cartService.removeItemFromCart(item, date);
                //     }
                //   });
                this.notyfService.toastDelay = 2000;
                this.notyfService.toastStyle = { 'background-color': '#A53736', 'color': 'white' };
                this.notyfService.toastContainerStyle = {
                    'z-index': '99999', 'right': '0', "bottom": "0", "margin-bottom": "38vh", 'text-align': 'center', 'width': '170px', "position": "fixed"
                };
                this.notyfService.success("Item Removed");
                this.cartService.removeItemFromCart(item, date);
            }
            // else {
            this.cartService.removeItemFromCart(item, date);
            // }
        }
    };
    MyCartComponent.prototype.youMayItemPlus = function (item) {
        var _this = this;
        this.localSt.clear('cartDates');
        var itemToAdd = this.suggestedItems.find(function (x) { return x.zf_id === item.id; });
        var dates = [];
        this.cartItems.forEach(function (dateObj) {
            if (!dateObj.datePast) {
                dates.push(dateObj.date);
            }
        });
        this.localSt.store('cartDates', dates);
        this.localSt.store('suggestedItemEndDate', itemToAdd.zf_end_date);
        this.modalService.open(CartDatesPromptComponent, { backdrop: 'static', keyboard: false }).result.then(function (response) {
            if (response.status) {
                _this.cartService.addSuggestedItem(itemToAdd, response.date);
                _this.youMayEnjoyItems.splice(_this.itemIndex, 1);
                _this.youMayDateFunction();
                _this.youMayEnjoyFunction();
            }
        });
    };
    MyCartComponent.prototype.closeMyCart = function () {
        this.localSt.store('showMyCart', false);
    };
    MyCartComponent.prototype.priceLoopFunction = function () {
        var _this = this;
        this.grandTotal = 0;
        this.orderTotal = 0;
        this.taxAmount = 0;
        this.cartItems.forEach(function (dateObj) {
            dateObj.dayTotal = 0;
            dateObj.nextDayDate = new Date((new Date(dateObj.date)).getTime() + (60 * 60 * 24 * 1000));
            dateObj.nextDayDate = new Date(dateObj.nextDayDate).toISOString().split('T')[0];
            dateObj.previousDayDate = new Date((new Date(dateObj.date)).getTime() - (60 * 60 * 24 * 1000));
            dateObj.previousDayDate = new Date(dateObj.previousDayDate).toISOString().split('T')[0];
            new Date(_this.currentDate) > new Date(dateObj.date) ? dateObj.datePast = true : dateObj.datePast = false;
            dateObj.items.forEach(function (item) {
                dateObj.dayTotal = dateObj.dayTotal + item.zf_price * item.count;
                if (item.freeItem) {
                    dateObj.dayTotal = dateObj.dayTotal - item.zf_price;
                }
                if (item.zf_is_taxable) {
                    var itemTax = (item.zf_price / 100) * _this.localSt.retrieve('taxPercentage');
                    _this.taxAmount = _this.taxAmount + itemTax * item.count;
                }
            });
            _this.orderTotal = _this.orderTotal + dateObj.dayTotal;
        });
        this.grandTotal = this.orderTotal;
        if (this.showPromoCodeApplied) {
            if (this.appliedPromoObject.discountType === 'amount' || this.appliedPromoObject.discountType === 'percentage') {
                // let freeItemPrice = this.appliedPromoObject.freeItem ? this.appliedPromoObject.freeItem.zf_price : 0;
                if (this.orderTotal < Number(this.appliedPromoObject.minAmount)) {
                    this.minimumSpendErrorMessage = 'To apply this promo code minimum order must be of $' + this.appliedPromoObject.minAmount;
                    this.showMinimumSpendError = true;
                }
                else {
                    this.showMinimumSpendError = false;
                    if (this.appliedPromoObject.discountType === 'amount') {
                        this.grandTotal = this.orderTotal - this.appliedPromoObject.discountValue;
                    }
                    if (this.appliedPromoObject.discountType === 'percentage') {
                        this.appliedPromoObject.discountValue = (this.orderTotal / 100) * this.appliedPromoObject.discountPercentageValue;
                        this.grandTotal = this.orderTotal - this.appliedPromoObject.discountValue;
                    }
                }
            }
            if (this.appliedPromoObject.discountType === 'free') {
                var found = false;
                var addItem = false;
                var freeItem = this.appliedPromoObject.freeItem;
                freeItem.freeItem = true;
                var addItemDate = '';
                for (var i = 0; i < this.cartItems.length; i++) {
                    this.freeItemNotAvailable = false;
                    var dateObj = this.cartItems[i];
                    for (var j = 0; j < dateObj.items.length; j++) {
                        var item = dateObj.items[j];
                        if (item.zf_id === this.appliedPromoObject.freeItem.zf_id) {
                            item.freeItem = true;
                            found = true;
                            break;
                        }
                    }
                }
                if (freeItem.zf_is_taxable) {
                    var itemTax = (freeItem.zf_price / 100) * this.localSt.retrieve('taxPercentage');
                    this.taxAmount = this.taxAmount - itemTax;
                }
                if (!found) {
                    for (var i = 0; i < this.cartItems.length; i++) {
                        this.freeItemNotAvailable = false;
                        var dateObj = this.cartItems[i];
                        // tslint:disable-next-line:max-line-length
                        if (new Date(this.appliedPromoObject.freeItem.zf_start_date) <= new Date(dateObj.date) && (new Date(this.appliedPromoObject.freeItem.zf_end_date) >= new Date(dateObj.date) || this.appliedPromoObject.freeItem.zf_end_date === null)) {
                            addItem = true;
                            addItemDate = dateObj.date;
                            break;
                            // tslint:disable-next-line:max-line-length
                        }
                        else if (new Date(this.appliedPromoObject.freeItem.zf_start_date) > new Date(dateObj.date) || new Date(this.appliedPromoObject.freeItem.zf_end_date) < new Date(dateObj.date)) {
                            this.freeItemNotAvailable = true;
                            this.freeItemNotAvailableMessage = this.appliedPromoObject.freeItem.zf_name + ' is not available for order date(s).';
                        }
                    }
                }
                if (!this.freeItemNotAvailable) {
                    this.promoFreeItemDiscount = this.appliedPromoObject.freeItem ? this.appliedPromoObject.freeItem.zf_price : 0;
                    if (this.orderTotal < Number(this.appliedPromoObject.minAmount)) {
                        this.minimumSpendErrorMessage = 'To apply this promo code minimum order must be of $' + this.appliedPromoObject.minAmount;
                        this.showMinimumSpendError = true;
                    }
                    else {
                        this.showMinimumSpendError = false;
                        if (addItem) {
                            this.cartService.addSuggestedItem(freeItem, addItemDate);
                        }
                        this.grandTotal = this.orderTotal - this.appliedPromoObject.discountValue;
                    }
                }
            }
        }
        else {
            this.promoFreeItemDiscount = 0;
        }
    };
    MyCartComponent.prototype.youMayDateFunction = function () {
        var _this = this;
        if (this.cartItems && this.cartItems.length) {
            this.youMayEnjoyReqObj = { dates: [], items: [] };
            for (var i = 0; i < this.cartItems.length; i++) {
                var item = this.cartItems[i];
                if (!item.datePast) {
                    this.youMayEnjoyReqObj.dates.push(item.date);
                    item.items.forEach(function (innerItem) {
                        _this.youMayEnjoyReqObj.items.push(innerItem.zf_id);
                    });
                }
            }
        }
        this.youMayEnjoyReqObj.items = this.youMayEnjoyReqObj.items.filter(this.onlyUnique);
        this.youMayEnjoyReqObj.dates = this.youMayEnjoyReqObj.dates.filter(this.onlyUnique);
    };
    MyCartComponent.prototype.onlyUnique = function (value, index, self) {
        return self.indexOf(value) === index;
    };
    MyCartComponent.prototype.youMayEnjoyFunction = function () {
        var _this = this;
        this.showYouMayEnjoyLoader = true;
        this.cartService.youMayEnjoy(this.youMayEnjoyReqObj).subscribe(function (res) {
            _this.showYouMayEnjoyLoader = false;
            _this.suggestedItems = res.data || [];
            _this.youMayEnjoyItems = res.data || [];
            if (_this.youMayEnjoyItems.length === 1) {
                _this.itemIndex = 0;
            }
            if (_this.youMayEnjoyItems && _this.youMayEnjoyItems.length) {
                _this.youMayEnjoyItemsShow = {
                    image: _this.youMayEnjoyItems[_this.itemIndex].zf_image_web,
                    price: _this.youMayEnjoyItems[_this.itemIndex].zf_price,
                    name: _this.youMayEnjoyItems[_this.itemIndex].zf_name,
                    id: _this.youMayEnjoyItems[_this.itemIndex].zf_id
                };
            }
        });
    };
    MyCartComponent.prototype.removeExpiredOrder = function (item) {
        var _this = this;
        this.modalService.open(RemovePastOrderComponent, { backdrop: 'static', keyboard: false }).result.then(function (response) {
            if (response) {
                _this.cartItems.forEach(function (dateObj, i) {
                    if (dateObj.date === item.date) {
                        _this.cartItems.splice(i, 1);
                    }
                });
                _this.localSt.store('cartItems', _this.cartItems);
            }
        });
    };
    MyCartComponent.prototype.cartItemSort = function () {
        this.cartItems.sort(function (a, b) {
            var keyA = new Date(a.date), keyB = new Date(b.date);
            // Compare the 2 dates
            if (keyA < keyB) {
                return -1;
            }
            if (keyA > keyB) {
                return 1;
            }
            return 0;
        });
    };
    MyCartComponent.prototype.myCartSelectedDateClick = function (date) {
        this.localSt.store('myCartSelectedDate', date);
    };
    MyCartComponent.prototype.addAnotherDeliveryClick = function () {
        this.localSt.store('addAnotherDelivery', this.addAnotherDelivery = !this.addAnotherDelivery);
    };
    MyCartComponent.prototype.deliveryCharges = function () {
        var _this = this;
        this.localSt.retrieve('zipCodes').forEach(function (zipCode) {
            if (zipCode.zf_zip_code === _this.localSt.retrieve('validZipCode')) {
                _this.deliveryFeeTotal = zipCode.zf_rate * _this.cartItems.length;
                _this.singleDayDeliveryFeeTotal = zipCode.zf_rate;
            }
        });
    };
    MyCartComponent.prototype.cancelPromoCode = function () {
        this.addPromoForm.reset();
        this.showPromoCodeForm = false;
        this.invalidPromo = false;
    };
    MyCartComponent.prototype.applyPromoCodeClick = function () {
        var _this = this;
        this.cartService.applyPromo(this.addPromoForm.value.promocode).subscribe(function (res) {
            if (res.statusCode === 200) {
                if (!res.data.zf_multiple_usage && !_this.localSt.retrieve('zenUser')) {
                    _this.errorMessage = 'Login or sign up to apply this code.';
                    _this.invalidPromo = true;
                }
                else {
                    if (res.data.zf_discount_type === 'free' && res.data.zf_free_item === null) {
                        _this.errorMessage = 'Invalid promo code';
                        _this.invalidPromo = true;
                    }
                    else {
                        _this.promoFreeItemDiscount = res.data.zf_free_item ? res.data.zf_free_item.zf_price : 0;
                        if (_this.orderTotal < Number(res.data.zf_minimum_spend)) {
                            _this.errorMessage = 'To apply this promo code minimum order must be of $' + res.data.zf_minimum_spend;
                            _this.invalidPromo = true;
                        }
                        else {
                            _this.appliedPromoObject = {
                                promoCode: _this.addPromoForm.value.promocode,
                                discountValue: res.data.zf_discount_value,
                                discountType: res.data.zf_discount_type,
                                minAmount: res.data.zf_minimum_spend,
                                multipleUsage: res.data.zf_multiple_usage
                            };
                            if (res.data.zf_discount_type === 'free') {
                                _this.appliedPromoObject.freeItem = res.data.zf_free_item;
                                _this.appliedPromoObject.discountValue = res.data.zf_free_item.zf_price;
                            }
                            if (res.data.zf_discount_type === 'percentage') {
                                _this.appliedPromoObject.discountPercentageValue = res.data.zf_discount_percentage;
                            }
                            _this.localSt.store('appliedPromo', _this.appliedPromoObject);
                            _this.addPromoForm.reset();
                            _this.showPromoCodeApplied = true;
                            _this.invalidPromo = false;
                            _this.priceLoopFunction();
                        }
                    }
                }
            }
            else {
                _this.errorMessage = res.message;
                _this.invalidPromo = true;
            }
        });
    };
    MyCartComponent.prototype.removePromoFunction = function () {
        this.cartItems.forEach(function (dateObj) {
            dateObj.items.forEach(function (item) {
                item.freeItem = false;
            });
        });
        this.localSt.clear('appliedPromo');
        this.showPromoCodeApplied = false;
        this.showPromoCodeForm = false;
        this.showMinimumSpendError = false;
        this.freeItemNotAvailable = false;
        this.promoFreeItemDiscount = 0;
        this.priceLoopFunction();
    };
    MyCartComponent.prototype.disableCheckOutFunc = function () {
        for (var i = 0; i < this.cartItems.length; i++) {
            var item = this.cartItems[i];
            if (item.datePast || item.dayTotal < 25) {
                this.disableCheckOutButton = true;
                break;
            }
            else {
                this.disableCheckOutButton = false;
            }
        }
    };
    MyCartComponent.prototype.continueCheckOutClick = function () {
        if (!this.localSt.retrieve('zenUser')) {
            this.localSt.clear('activeCheckoutStep');
            this.localSt.clear('doneCheckoutSteps');
        }
    };
    return MyCartComponent;
}());
export { MyCartComponent };



// WEBPACK FOOTER //
// ./src/app/modules/shared/my-cart/my-cart.component.ts.pre-build-optimizer.js